const STEPS = [
  {
    n: "01",
    title: "Get in touch",
    body: "Tell us a little about yourself, your plan and what good support looks like for you.",
  },
  {
    n: "02",
    title: "Free consultation",
    body: "We meet you (in person, phone or video) to listen, answer questions and explore options.",
  },
  {
    n: "03",
    title: "Build your plan",
    body: "Together we craft a tailored support schedule that aligns with your NDIS goals.",
  },
  {
    n: "04",
    title: "Ongoing support",
    body: "Consistent support workers, regular check‑ins and adjustments as your needs evolve.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="py-20 md:py-28 bg-brand-bone"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-2xl">
          <span className="text-xs uppercase tracking-[0.22em] text-brand-terracotta font-semibold">
            How NDIS works with us
          </span>
          <h2 className="mt-3 font-heading font-semibold tracking-tight text-brand-forest text-3xl sm:text-4xl lg:text-5xl">
            Four gentle steps to feeling supported.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              data-testid={`step-${s.n}`}
              className="relative bg-white rounded-2xl border border-brand-sand p-7 shadow-sm hover:shadow-md transition-shadow"
            >
              <span className="font-heading text-5xl font-bold text-brand-terracotta/25 leading-none">{s.n}</span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-brand-ink">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-muted">{s.body}</p>
              {i < STEPS.length - 1 && (
                <span className="hidden lg:block absolute top-1/2 -right-3 h-px w-6 bg-brand-sand" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
